jQuery(document).ready(function($) {
  var slot_num;
  var slot_template;
  $('.add-slot').click(function(event) {
    event.preventDefault();
    slot_num = parseInt($('input[name="num_slots"]').val());
    slot_template = $('.slot-template').html().replaceAll("slot_number", slot_num);
    $('.slots-hold').append(slot_template);
    slot_num = slot_num + 1;
    $('input[name="num_slots"]').val(slot_num);
    check_slots();
  });

  $('body').on('click', '.remove-slot', function(event) {
    event.preventDefault();
    $(this).parent().parent().slideUp(300, function() {
      $(this).remove();
      check_slots();
    });
  });

  $('.add-exclude-date').click(function(event) {
    event.preventDefault();
    exclude_date_num = parseInt($('input[name="num_exclude_dates"]').val());
    exclude_template = $('.exclude-date-template').html().replaceAll("exclude_date_number", exclude_date_num);
    $('.exclude-dates-hold').append(exclude_template);
    exclude_date_num = exclude_date_num + 1;
    $('input[name="num_exclude_dates"]').val(exclude_date_num);
    check_exclusion_dates();
  });

  $('body').on('click', '.remove-exclude-date', function(event) {
    event.preventDefault();
    $(this).parent().parent().slideUp(300, function() {
      $(this).remove();
      check_exclusion_dates();
    });
    
  });

  check_exclusion_dates();
  function check_exclusion_dates() {
    exclude_count = $('.exclude-dates-hold .exclude-date:not(.show-if-none)').length;
    if(exclude_count) {
      $('.exclude-dates-hold .exclude-date.show-if-none').hide();
    } else {
      $('.exclude-dates-hold .exclude-date.show-if-none').show();
    }
  }

  check_slots();
  function check_slots() {
    exclude_count = $('.slots-hold .slot:not(.show-if-none)').length;
    if(exclude_count) {
      $('.slots-hold .slot.show-if-none').hide();
    } else {
      $('.slots-hold .slot.show-if-none').show();
    }
  }

  $('.select-2-box').select2({
    theme: "bootstrap-5",
  });
});
